/**
 * Получение данных из хранилища
 */
export default function (key: string, storage: Storage = window.localStorage) {
	const data = storage.getItem(key);
	return data ? JSON.parse(data) : null;
}
